import '../../App.css';
import React, { useContext, useEffect, useState } from "react";
import { FaTimes } from 'react-icons/fa';
import { ApiContext } from '../../context/ApiContext';
import { StyleContext } from '../../context/StyleContext';

function ModalNovoCadastro({ closeModal, end, currentPage }) {

    const { getEmpresa, AdicionarItensDemanda } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)
    const [Descricao, setDescricao] = useState()
    const [Status, setStatus] = useState(true)

    const salvarDemanda = () => {
        AdicionarItensDemanda(end, Descricao, Status, currentPage)
            .then(() => {
                closeModal(false)
            })
            .catch((error) => {
                console(error)
            })
    }

    useEffect(() => {
        getEmpresa()
    }, [])

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <div>
                        <h1 className="h1-modal">Novo cadastro</h1>
                    </div>
                    <div className="btn-close-modal" onClick={() => closeModal(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div className="modal-content">
                    <form className="mb-3">
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label className="modal-label">Descrição:</label>
                            <textarea required name="descricao" className="modal-input" rows={3} onChange={(e) => setDescricao(e.target.value)} />
                        </div>
                        <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                            <input type="checkbox" label="Ativo" name='status' checked={Status} onChange={(e) => setStatus(e.target.checked)} className="toggleBtn" />
                            <p className="modal-status">Ativo</p>
                        </div>
                    </form>
                </div>
                <div className="footer-modal">
                    <button type="submit" className="btn-dash btn-ver" style={btnVer} onClick={() => closeModal(false)}>Cancelar</button>
                    <button type="submit" className="btn-dash btn-criar" style={btnCriar} onClick={() => salvarDemanda()}>Salvar</button>
                </div>
            </div>
        </div>
    )
}

export default ModalNovoCadastro